import { render, staticRenderFns } from "./phone-input.vue?vue&type=template&id=63b2d88a&scoped=true&lang=pug&"
import script from "./phone-input.vue?vue&type=script&lang=ts&"
export * from "./phone-input.vue?vue&type=script&lang=ts&"
import style0 from "./phone-input.vue?vue&type=style&index=0&id=63b2d88a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b2d88a",
  null
  
)

export default component.exports